/**
 * @generated SignedSource<<402ecaf7ac4980832658d4cf5cf2d119>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobileSummaryNewPane_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDutiesMessage_viewer" | "CheckoutMobilePromotion_viewer">;
  readonly " $fragmentType": "CheckoutMobileSummaryNewPane_viewer";
};
export type CheckoutMobileSummaryNewPane_viewer$key = {
  readonly " $data"?: CheckoutMobileSummaryNewPane_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryNewPane_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobileSummaryNewPane_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobilePromotion_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDutiesMessage_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "577543adc4722bfb03da2320b7aa18a7";

export default node;
